<div class="text-center flex items-center flex-col gap-4">
  <img
    src="./assets/images/logos/incidite-head-white.svg"
    alt="Incidite Logo"
    class="w-8 h-8" />
  <div class="flex flex-col gap-2">
    <h1 class="text-2xl font-medium">{{ header() }}</h1>
    @if (subheader(); as subheader) {
      <p class="text-subtle">{{ subheader }}</p>
    }
  </div>
</div>
